import Button from "@/components/ui/button";

export default function WallOfLoveEmptyPlaceholder({ onClick }: { onClick: () => void }) {
	return (
		<div className="flex w-full bg-white rounded-xl border border-gray-200 overflow-hidden items-stretch">
			<div className="border-r border-gray-200 shrink-0">
				<div className="relative w-full h-full max-w-lg" style={{ minHeight: "200px" }}>
					<img className="w-full h-full object-cover" src="/images/wall-default-template-light.jpg" alt="Wall of Love Empty Placeholder" />
				</div>
			</div>
			<div className="flex flex-col justify-center space-y-4 p-6 px-8">
				<div>
					<h3 className="text-lg font-semibold text-gray-900 mb-2">Create your first wall of love</h3>
					<p className="text-sm text-gray-500">Get started by creating your first wall of love. Wall of love helps you collect and manage testimonials efficiently.</p>
				</div>
				<Button type="button" onClick={onClick}>
					Create Wall of Love
				</Button>
			</div>
		</div>
	);
}
